export default {
  subtitle: 'グローバル環境に特化した転職エージェント',
  about: {
    header: '転職エージェント「G Talent」とは？',
    body: 'は、IT・機電領域に特化したグローバル人材向け転職支援サービスです。エンジニア職から、PM・ブリッジSEなどのマネジメント・専門職まで、幅広いポジションに対応。グローバル環境でキャリアを伸ばしたい即戦力・ハイクラス人材の転職を、専門性の高い多国籍チームが支援します。',
    highlight: 'G Talent（ジータレント）'
  },
  why: {
    header: 'G Talent の強み',
    expertSupport: {
      title: 'asd',
      body: '日本人を含む多国籍のバイリンガルアドバイザーが、英語・中国語・ベトナム語などで転職成功まで徹底サポート'
    },
    careerAdvancement: {
      title: 'asd',
      body: '即戦力・ハイクラス人材に特化し、市場価値を踏まえた最適提案で年収・ポジションの最大化を実現'
    }
  },
  applicationProcess: {
    header: '応募後の流れ',
    body: '応募後は、選任アドバイザーがキャリア面談を行い、あなたの強みや志向を整理したうえで最適な企業へ推薦いたします。',
    steps: {
      applicationRegistration: '応募・会員登録',
      careerConsultation: 'キャリア面談',
      referralToEmployer: '企業への推薦',
      selectionJobOffer: '選考・内定'
    },
    noteTitle: 'asd',
    noteBody: '※既に登録済みの方：担当者より改めてご連絡し、ご推薦手続きに進みます。',
    disclaimerTitle: 'asd',
    disclaimerBody: '※ご経歴や求人状況により、面談のご案内が難しい場合がございます。あらかじめご了承ください。'
  }
}
